// extracted by mini-css-extract-plugin
export default {"img":"Icons_img__Phtx8","transform":"Icons_transform__ukb5Y","insta":"Icons_insta__UcHAC","youtube":"Icons_youtube__IbvUr","block":"Icons_block__keqcP"};